import React from 'react';

const styles = {
  skeletonContainer: {
    backgroundColor: '#222',
    borderRadius: '8px',
    padding: '1rem',
    marginBottom: '2rem',
  },
  skeletonTitle: {
    width: '200px',
    height: '30px',
    backgroundColor: '#444',
    borderRadius: '4px',
    marginBottom: '1rem',
  },
  skeletonViewAll: {
    width: '80px',
    height: '20px',
    backgroundColor: '#444',
    borderRadius: '4px',
  },
  skeletonRow: {
    display: 'flex',
    gap: '1rem',
  },
  skeletonCard: {
    width: '180px',
    height: '100px',
    backgroundColor: '#333',
    borderRadius: '6px',
    marginBottom: '0.5rem',
  },
  skeletonText: {
    width: '80%',
    height: '20px',
    backgroundColor: '#444',
    borderRadius: '4px',
  },
};

export default function CategorySkeleton({ count = 3 }) {
  return (
    <section className="container">
      {[...Array(count)].map((_, index) => (
        <div key={index} style={styles.skeletonContainer}>
          <div className="d-flex flex-row justify-content-between align-items-center mb-3">
            <div style={styles.skeletonTitle}></div>
            <div style={styles.skeletonViewAll}></div>
          </div>
          <div style={styles.skeletonRow}>
            {[...Array(2)].map((_, i) => (
              <div key={i}>
                <div style={styles.skeletonCard}></div>
                <div style={styles.skeletonText}></div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
